module.exports = __webpack_public_path__ + "img/rating-1.232f9fc1.png";